import { useState , useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import useApp from "../context/AppContext";
import { api } from "../utils/api";

const Login = () => {
  const { showModalError, showModalMessage, setUsuario, setLoading, loaded, verificaUser } = useApp();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const classCNPJ = username === "" ? "input100" : "input100 has-val";
  const classPassword = password === "" ? "input100" : "input100 has-val";
  const CNPJMask = "99.999.999/9999-99";

  useEffect(() => {
    if (loaded && verificaUser()) 
      navigate("/listarDocumentos");
  }, [loaded]);

  const submit = ()=>{    
    setLoading(true);
    api().post("/auth/signin", { username, password })
      .then((resp) => {
        if (resp.status === 200) {  
          setUsuario({...resp.data}) 
          navigate("/listarDocumentos");  
          setLoading(false);
        }
        else{        
          showModalMessage("Aviso", <h2>{resp.data}</h2>);
        }
      })
      .catch((error)=> {
        if (error.response.status===400) {
          showModalMessage("Aviso", <h2>{error.response.data}</h2>);
        }
        else
        showModalError("Erro ao acessar servidor");
      })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit();
    event.preventDefault();
  };
  return (
    <>
      <div className="limiter bghome">
        <div className="container-login100">
          <div className="wrap-login100 p-20">
            <form className="login100-form validate-form" onSubmit={handleSubmit} >
              <span className="login100-form-title">Portal de Fornecedores</span>
              <span className="login100-form-subtitle">Login de acesso</span>
              <div className="wrap-input100 validate-input m-t-55 m-b-35" data-validate="Entre com o CNPJ">
                <InputMask
                  maskPlaceholder={"*"}
                  mask={CNPJMask}
                  required
                  value={username}
                  onChange={(e) => setUsername(e.currentTarget.value)}
                >
                  {() => <input type="text" className="input100 has-val" name="CNPJ" id="produto-1-cnpj" autoComplete="nope" />}
                </InputMask>
                <span className="focus-input100" data-placeholder="CNPJ"></span>
              </div>
              <div className="wrap-input100 validate-input m-b-50" data-validate="Enter com a senha">
                <input
                  className="input100 has-val"
                  type="password"
                  name="pass"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.currentTarget.value)}
                  onBlur={(e)=> { if (password !== "") submit()}} 
                  autoComplete="nope"
                />
                <span className="focus-input100" data-placeholder="Senha"></span>
              </div>

              <div className="container-login100-form-btn">
                <input type="submit" className="login100-form-btn" value="ENTRAR" />
              </div>

              <ul className="login-more p-t-60 ps-0 mb-0">
                <li className="m-b-8">
                  <span className="txt1">Não tem ou não sabe sua senha? </span>
                  <Link to="/cadastrarSenha" className="txt2">
                    Gere uma nova!
                  </Link>
                </li>
              </ul>
            </form>
            <span className="urbam_footer">URBAM - URBANIZADORA MUNICIPAL S.A</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
